import { useEffect, useState } from "react";
import { searchSuggestionsByTitle, Suggestion } from "../apis/search-catalog";

const DEFAULT_LIMIT = 3;

interface SearchSuggestionsByTitleProps {
  value: string;
  limit?: number;
}

export const useSearchSuggestionsByTitle = ({
  value,
  limit = DEFAULT_LIMIT,
}: SearchSuggestionsByTitleProps) => {
  const [data, setData] = useState<Suggestion[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<unknown>(null);

  useEffect(() => {
    let isActive = true;

    if (!value || value.length < 2) {
      setData([]);
      setLoading(false);
      setError(null);
      return;
    }

    const load = async () => {
      setLoading(true);
      setError(null);
      try {
        const suggestions = await searchSuggestionsByTitle(value, limit);
        if (isActive) {
          setData(suggestions);
        }
      } catch (err) {
        if (isActive) {
          setError(err);
          setData([]);
        }
      } finally {
        if (isActive) {
          setLoading(false);
        }
      }
    };

    load();

    return () => {
      isActive = false;
    };
  }, [limit, value]);

  return { data, loading, error };
};
